module.exports = __webpack_public_path__ + "img/Planet.77e9792c.svg";